import { useEffect, useMemo, useRef, useState } from "react";


import { useNavigate } from "react-router-dom";


import { useAuth } from "../../context/AuthContext";


import { getCurrentSalonName } from "../../utils/currentSalon";


import { getCurrentSalonId } from "../../utils/currentSalon";


import {



  getPortalSettings,



  updatePortalSettings,



} from "../../api/clientPortalAdmin";



import { listSalonUsers } from "../../api/salonUsers";


import TimeSelect from "../../components/TimeSelect";


import InfoTooltip from "../../components/common/InfoTooltip";


import ModalCloseX from "../../components/common/ModalCloseX";


import {


  reviewFieldHelp,


  reviewSetupGuideNote,


  reviewSetupGuideSteps,



  reviewTooltips,



} from "../../constants/clientReviewsHelp";
import SafeHtml from "../../components/common/SafeHtml";







const GUIDE_BODY_ID = "client-reviews-setup-guide-body";

const CLIENT_REVIEW_SECTION_LINKS = [
  ["client-review-settings", "Review settings"],
  ["client-review-preview", "Live preview"],
  ["client-review-copy", "Form copy"],
  ["client-review-questions", "Questions"],
  ["client-review-comments", "Comments"],
  ["client-review-thank-you", "Thank-you"],
  ["client-review-public-cta", "Public CTA"],
  ["client-review-public-rules", "Public rules"],
  ["client-review-kpis", "KPI rules"],
  ["client-review-followups", "Follow-ups"],
  ["client-review-email", "Email message"],
];

const SaveChangesButton = ({ saving, className = "" }) => (
  <button
    type="submit"
    disabled={saving}
    className={`h-10 rounded-full bg-slate-900 px-4 text-xs md:text-sm font-semibold text-white hover:bg-slate-800 disabled:opacity-60 ${className}`}
  >
    {saving ? "Saving..." : "Save Changes"}
  </button>
);




const normalizeTime = (value) => {



  if (value == null) return "";



  const str = String(value).trim();



  if (!str) return "";



  const parts = str.split(":");



  const hours = Number(parts[0]);



  if (Number.isNaN(hours)) return "";



  let minutesPart = parts[1] || "00";



  const digits = minutesPart.match(/^(\d+)/);



  let minutes = digits ? Number(digits[1]) : 0;



  if (Number.isNaN(minutes)) {



    minutes = 0;



  }



  minutes = Math.max(0, Math.min(59, minutes));



  return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}`;



};







const cleanText = (value) => {



  if (value == null) return null;



  const trimmed = String(value).trim();



  return trimmed ? trimmed : null;



};







const toNumberOr = (value, fallback) => {



  if (value === "" || value == null) return fallback;



  const num = Number(value);



  return Number.isFinite(num) ? num : fallback;



};







const DEFAULT_REVIEW_QUESTION_CONFIG = {
  overall: {
    label: "Overall experience",
    enabled: true,
    required: true,
    locked: true,
  },
  salon: { label: "Salon atmosphere", enabled: true, required: true },
  reception: { label: "Reception", enabled: true, required: true },
  service: { label: "Service quality", enabled: true, required: true },
  staff: { label: "Staff professionalism", enabled: true, required: true },
  online_booking: { label: "Online booking", enabled: true, required: false },
  technician_service: {
    label: "Service quality",
    enabled: true,
    required: false,
  },
  technician_staff: {
    label: "Staff professionalism",
    enabled: true,
    required: false,
  },
};

const normalizeReviewQuestionConfig = (value) => {
  const source = value && typeof value === "object" ? value : {};
  return Object.fromEntries(
    Object.entries(DEFAULT_REVIEW_QUESTION_CONFIG).map(([key, defaults]) => {
      const incoming =
        source[key] && typeof source[key] === "object" ? source[key] : {};
      const locked = Boolean(defaults.locked);
      const required = locked
        ? true
        : Boolean(incoming.required ?? defaults.required);
      const enabled = locked
        ? true
        : required || Boolean(incoming.enabled ?? defaults.enabled);
      return [
        key,
        {
          ...defaults,
          label: String(incoming.label || defaults.label).trim() || defaults.label,
          enabled,
          required,
        },
      ];
    })
  );
};


const DEFAULT_FORM = {
  review_email_enabled: true,


  review_email_template_enabled: false,
  review_email_subject: "How was your visit at {{salon_name}}?",
  review_email_body:
    "Hi {{client_first_name}},\nThank you for visiting {{salon_name}} today. We'd love your feedback.\nPlease leave a quick review here: {{feedback_url}}\nIf anything wasn't perfect, reply to this email or call us at {{salon_phone}} so we can make it right.\nThank you,\n{{signature_name}}",
  review_expiry_days: 14,
  review_form_title: "Client Feedback",
  review_form_subtitle: "Thank you for taking a moment to share your experience.",
  review_comment_enabled: true,
  review_comment_label: "Additional comments",
  review_comment_required_below_rating: 4,
  review_comment_required_message:
    "We're sorry it wasn't perfect - could you share a quick note so we can improve?",
  review_thank_you_title: "Feedback received. Thank you!",
  review_thank_you_message: "Thank you - your feedback was sent to the salon.",
  review_question_config: DEFAULT_REVIEW_QUESTION_CONFIG,
  review_send_mode: "on_close",
  review_send_delay_minutes: 0,


  review_quiet_hours_enabled: true,


  review_quiet_start_local: "20:00",


  review_quiet_end_local: "09:00",


  review_reminder_enabled: false,


  review_reminder_delay_days: 3,


  review_reminder_max_count: 1,


  review_kpi_min_reviews: 10,


  review_kpi_window_days: 90,


  review_kpi_weight_overall: 60,


  review_kpi_weight_service: 25,


  review_kpi_weight_staff: 15,


  review_followup_enabled: true,


  review_followup_threshold: 3,


  review_followup_default_assignee_user_id: "",


  followup_sla_enabled: true,


  followup_sla_hours: 24,


  followup_overdue_reminder_hours: 24,


  followup_auto_assign_enabled: true,


  followup_manager_notify_email: "",


  public_review_ask_enabled: true,


  public_review_ask_threshold: 4,


  public_review_ask_mode: "immediate",


  public_review_ask_delay_hours: 24,


  public_review_ask_require_comment: false,
  public_review_ask_min_feedback_length: 0,
  public_review_ask_cta_text: "Leave a public review",
  public_review_ask_helper_text:
    "If you have a moment, we would appreciate a public review.",
  public_review_ask_ab_test_enabled: false,
  public_review_ask_variant_a_subject: "Thanks for your feedback",


  public_review_ask_variant_a_body:


    "Hi {{client_first_name}},\nThanks again for visiting {{salon_name}}. If you have a moment, we'd appreciate a public review: {{public_review_link}}\n",


  public_review_ask_variant_b_subject: "",


  public_review_ask_variant_b_body: "",


  public_review_ask_variant_split_pct: 50,


  feedback_first_enabled: true,


  csat_goal_enabled: true,


  csat_goal_target_rating: 4.6,


  csat_goal_target_reviews_per_week: 10,


  google_review_url: "",


  review_notify_email: "",


};





const EMAIL_TOKENS = [


  "{{client_first_name}}",


  "{{salon_name}}",


  "{{salon_phone}}",


  "{{review_url}}",


  "{{feedback_url}}",


  "{{ticket_number}}",


  "{{service_date}}",


  "{{signature_name}}",


  "{{unsubscribe_url}}",


];





const escapeHtml = (value) =>


  String(value || "")


    .replace(/&/g, "&amp;")


    .replace(/</g, "&lt;")


    .replace(/>/g, "&gt;")


    .replace(/\"/g, "&quot;")


    .replace(/'/g, "&#39;");





const replaceTokens = (template, values) =>


  String(template || "").replace(


    /{{\s*([a-zA-Z0-9_]+)\s*}}/g,


    (match, key) => (values?.[key] ? String(values[key]) : "")


  );





const StarPreviewRow = ({ label, required }) => (
  <div className="space-y-2">
    <div className="flex items-center gap-2 text-sm font-semibold text-slate-700">
      <span>{label}</span>
      {required && <span className="text-xs font-normal text-rose-500">Required</span>}
    </div>
    <div className="flex flex-wrap gap-2 text-slate-200">
      {[1, 2, 3, 4, 5].map((value) => (
        <span key={value} className="text-3xl leading-none">
          {"\u2605"}
        </span>
      ))}
    </div>
  </div>
);


const SAMPLE_FEEDBACK_SERVICE = "BIOGEL REFILL";
const SAMPLE_FEEDBACK_TECHNICIAN = "Helen C";

const ClientFeedbackLivePreview = ({
  form,
  salonName,
  onOpenPreview,
  previewFeedbackUrl,
  previewAsPortalBooking,
  onPreviewAsPortalBookingChange,
  onCopyPreviewLink,
}) => {
  const questions = normalizeReviewQuestionConfig(form.review_question_config);
  const enabled = (key) => questions[key]?.enabled !== false;
  const required = (key) => Boolean(questions[key]?.required);
  const label = (key) => questions[key]?.label || DEFAULT_REVIEW_QUESTION_CONFIG[key]?.label;
  const formTitle = form.review_form_title || DEFAULT_FORM.review_form_title;
  const formSubtitle =
    form.review_form_subtitle || DEFAULT_FORM.review_form_subtitle;
  const commentEnabled = form.review_comment_enabled !== false;
  const commentLabel =
    form.review_comment_label || DEFAULT_FORM.review_comment_label;
  const thankYouTitle =
    form.review_thank_you_title || DEFAULT_FORM.review_thank_you_title;
  const thankYouMessage =
    form.review_thank_you_message || DEFAULT_FORM.review_thank_you_message;
  const publicReviewCta =
    form.public_review_ask_cta_text || DEFAULT_FORM.public_review_ask_cta_text;
  const publicReviewHelper =
    form.public_review_ask_helper_text ||
    DEFAULT_FORM.public_review_ask_helper_text;

  return (
  <div className="rounded-2xl border border-slate-200 bg-white p-5 space-y-5">
    <div className="flex flex-wrap items-center justify-between gap-3">
      <div>
        <div className="text-base md:text-lg font-semibold text-slate-900">
          Live Preview
        </div>
        <div className="text-sm text-slate-500">
          This is exactly what clients will see.
        </div>
      </div>
      <button
        type="button"
        onClick={onOpenPreview}
        className="rounded-full border border-slate-300 px-4 py-2 text-xs md:text-sm font-semibold text-slate-700 hover:bg-slate-50"
      >
        Preview Survey Link
      </button>
    </div>
    <label className="flex items-center gap-3 text-sm text-slate-700">
      <input
        type="checkbox"
        checked={previewAsPortalBooking}
        onChange={(event) => onPreviewAsPortalBookingChange(event.target.checked)}
        className="h-4 w-4 rounded border-slate-300 text-slate-900"
      />
      <span className="font-semibold">Preview as Portal Booking</span>
    </label>
    {previewFeedbackUrl && (
      <div className="rounded-xl border border-slate-200 bg-slate-50 px-3 py-2 text-xs text-slate-600 flex items-center justify-between gap-2">
        <span className="truncate">{previewFeedbackUrl}</span>
        <button
          type="button"
          onClick={onCopyPreviewLink}
          className="text-xs font-semibold text-slate-700 hover:text-slate-900"
        >
          Copy
        </button>
      </div>
    )}
    <div className="rounded-2xl border border-rose-100 bg-rose-50 px-5 py-4">
      <div className="text-xl font-semibold text-slate-900">{formTitle}</div>
      <div className="mt-1 text-sm text-slate-600">{formSubtitle}</div>
    </div>
    <div className="rounded-2xl border border-slate-200 bg-white p-4 space-y-1">
      <div className="text-sm text-slate-500">Salon</div>
      <div className="text-lg md:text-xl font-semibold text-slate-900">
        {salonName || "Your Salon"}
      </div>
      <div className="text-sm text-slate-500">
        Visit date:{" "}
        {new Date().toLocaleDateString("en-US", {
          month: "short",
          day: "numeric",
          year: "numeric",
        })}
      </div>
      <div className="text-sm text-slate-500">
        Service performed: {SAMPLE_FEEDBACK_SERVICE}
      </div>
      <div className="text-sm text-slate-500">
        Technician: {SAMPLE_FEEDBACK_TECHNICIAN}
      </div>
    </div>
    <div className="rounded-2xl border border-slate-200 bg-white p-5 space-y-5">
      <StarPreviewRow label={label("overall")} required />
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
        {enabled("salon") && (
          <StarPreviewRow label={label("salon")} required={required("salon")} />
        )}
        {enabled("reception") && (
          <StarPreviewRow
            label={label("reception")}
            required={required("reception")}
          />
        )}
        {enabled("service") && (
          <StarPreviewRow label={label("service")} required={required("service")} />
        )}
        {enabled("staff") && (
          <StarPreviewRow label={label("staff")} required={required("staff")} />
        )}
        {previewAsPortalBooking && enabled("online_booking") && (
          <StarPreviewRow
            label={label("online_booking")}
            required={required("online_booking")}
          />
        )}
      </div>
      {(enabled("technician_service") || enabled("technician_staff")) && (
      <div className="rounded-2xl border border-slate-200 bg-white p-4 space-y-4">
        <div className="text-sm font-semibold text-slate-700">
          Rate your technician(s)
        </div>
        <div className="rounded-xl border border-slate-200 bg-slate-50 p-4 space-y-3">
          <div className="text-sm font-semibold text-slate-900">
            {SAMPLE_FEEDBACK_TECHNICIAN}
          </div>
          <div className="text-xs text-slate-600">
            Service performed: {SAMPLE_FEEDBACK_SERVICE}
          </div>
          <div className="grid grid-cols-1 gap-3 md:grid-cols-2">
            {enabled("technician_service") && (
              <StarPreviewRow
                label={label("technician_service")}
                required={required("technician_service")}
              />
            )}
            {enabled("technician_staff") && (
              <StarPreviewRow
                label={label("technician_staff")}
                required={required("technician_staff")}
              />
            )}
          </div>
          <div className="space-y-2">
            <label className="text-sm font-semibold text-slate-700">
              Comment (optional)
            </label>
            <textarea
              rows={3}
              disabled
              className="w-full rounded-xl border border-slate-300 bg-white px-4 py-3 text-sm text-slate-500"
              placeholder="Share feedback for this technician."
            />
          </div>
        </div>
      </div>
      )}
      {commentEnabled && (
        <div className="space-y-2">
          <label className="text-sm font-semibold text-slate-700">
            {commentLabel}
            {form.review_comment_required_below_rating ? (
              <span className="ml-2 text-xs font-normal text-slate-500">
                Required below {form.review_comment_required_below_rating}
              </span>
            ) : null}
          </label>
          <textarea
            rows={3}
            disabled
            className="w-full rounded-xl border border-slate-300 bg-white px-4 py-3 text-sm text-slate-500"
            placeholder="Share anything else you would like us to know."
          />
        </div>
      )}
      <label className="flex items-start gap-3 text-sm text-slate-700">
        <input
          type="checkbox"
          checked
          disabled
          readOnly
          className="mt-1 h-4 w-4 rounded border-slate-300 text-slate-900"
        />
        <span>It is okay for the salon to contact me about this feedback.</span>
      </label>
      <label className="flex items-start gap-3 text-sm text-slate-700">
        <input
          type="checkbox"
          disabled
          readOnly
          className="mt-1 h-4 w-4 rounded border-slate-300 text-slate-900"
        />
        <span>Request a manager call.</span>
      </label>
      <button
        type="button"
        disabled
        className="rounded-full bg-rose-500 px-6 py-3 text-sm font-semibold text-white opacity-60"
      >
        Submit feedback
      </button>
    </div>
    <div className="rounded-2xl border border-emerald-200 bg-emerald-50 px-4 py-3 text-sm text-emerald-800">
      <div className="font-semibold text-emerald-900">{thankYouTitle}</div>
      <div>{thankYouMessage}</div>
      {form.public_review_ask_enabled ? (
        <div className="mt-3 space-y-2">
          <div>{publicReviewHelper}</div>
          <button
            type="button"
            disabled
            className="rounded-full bg-rose-500 px-4 py-2 text-xs font-semibold text-white opacity-70"
          >
            {publicReviewCta}
          </button>
        </div>
      ) : (
        <div className="mt-2">Public review ask is turned off.</div>
      )}
    </div>
  </div>
  );
};


const buildFormState = (settings = {}) => ({
  ...DEFAULT_FORM,


  review_email_enabled: settings?.review_email_enabled !== false,


  review_email_template_enabled: Boolean(settings?.review_email_template_enabled),


  review_email_subject:


    settings?.review_email_subject || DEFAULT_FORM.review_email_subject,


  review_email_body:
    settings?.review_email_body || DEFAULT_FORM.review_email_body,
  review_expiry_days: Number.isFinite(settings?.review_expiry_days)
    ? Number(settings.review_expiry_days)
    : DEFAULT_FORM.review_expiry_days,
  review_form_title: settings?.review_form_title || DEFAULT_FORM.review_form_title,
  review_form_subtitle:
    settings?.review_form_subtitle || DEFAULT_FORM.review_form_subtitle,
  review_comment_enabled: settings?.review_comment_enabled !== false,
  review_comment_label:
    settings?.review_comment_label || DEFAULT_FORM.review_comment_label,
  review_comment_required_below_rating: Number.isFinite(
    settings?.review_comment_required_below_rating
  )
    ? Number(settings.review_comment_required_below_rating)
    : DEFAULT_FORM.review_comment_required_below_rating,
  review_comment_required_message:
    settings?.review_comment_required_message ||
    DEFAULT_FORM.review_comment_required_message,
  review_thank_you_title:
    settings?.review_thank_you_title || DEFAULT_FORM.review_thank_you_title,
  review_thank_you_message:
    settings?.review_thank_you_message || DEFAULT_FORM.review_thank_you_message,
  review_question_config: normalizeReviewQuestionConfig(
    settings?.review_question_config
  ),
  review_send_mode: settings?.review_send_mode || "on_close",
  review_send_delay_minutes: Number.isFinite(settings?.review_send_delay_minutes)



    ? Number(settings.review_send_delay_minutes)



    : DEFAULT_FORM.review_send_delay_minutes,



  review_quiet_hours_enabled: settings?.review_quiet_hours_enabled !== false,



  review_quiet_start_local: normalizeTime(



    settings?.review_quiet_start_local || DEFAULT_FORM.review_quiet_start_local



  ),
  review_quiet_end_local: normalizeTime(



    settings?.review_quiet_end_local || DEFAULT_FORM.review_quiet_end_local



  ),



  review_reminder_enabled: Boolean(settings?.review_reminder_enabled),



  review_reminder_delay_days: Number.isFinite(settings?.review_reminder_delay_days)



    ? Number(settings.review_reminder_delay_days)



    : DEFAULT_FORM.review_reminder_delay_days,



  review_reminder_max_count: Number.isFinite(settings?.review_reminder_max_count)



    ? Number(settings.review_reminder_max_count)



    : DEFAULT_FORM.review_reminder_max_count,



  review_kpi_min_reviews: Number.isFinite(settings?.review_kpi_min_reviews)



    ? Number(settings.review_kpi_min_reviews)



    : DEFAULT_FORM.review_kpi_min_reviews,



  review_kpi_window_days: Number.isFinite(settings?.review_kpi_window_days)



    ? Number(settings.review_kpi_window_days)



    : DEFAULT_FORM.review_kpi_window_days,



  review_kpi_weight_overall: Number.isFinite(settings?.review_kpi_weight_overall)



    ? Number(settings.review_kpi_weight_overall)



    : DEFAULT_FORM.review_kpi_weight_overall,



  review_kpi_weight_service: Number.isFinite(settings?.review_kpi_weight_service)



    ? Number(settings.review_kpi_weight_service)



    : DEFAULT_FORM.review_kpi_weight_service,



  review_kpi_weight_staff: Number.isFinite(settings?.review_kpi_weight_staff)



    ? Number(settings.review_kpi_weight_staff)



    : DEFAULT_FORM.review_kpi_weight_staff,



  review_followup_enabled: settings?.review_followup_enabled !== false,



  review_followup_threshold: Number.isFinite(settings?.review_followup_threshold)



    ? Number(settings.review_followup_threshold)



    : DEFAULT_FORM.review_followup_threshold,



  review_followup_default_assignee_user_id:


    settings?.review_followup_default_assignee_user_id != null


      ? String(settings.review_followup_default_assignee_user_id)


      : "",


  followup_sla_enabled: settings?.followup_sla_enabled !== false,


  followup_sla_hours: Number.isFinite(settings?.followup_sla_hours)


    ? Number(settings.followup_sla_hours)


    : DEFAULT_FORM.followup_sla_hours,


  followup_overdue_reminder_hours: Number.isFinite(


    settings?.followup_overdue_reminder_hours


  )


    ? Number(settings.followup_overdue_reminder_hours)


    : DEFAULT_FORM.followup_overdue_reminder_hours,


  followup_auto_assign_enabled: settings?.followup_auto_assign_enabled !== false,


  followup_manager_notify_email: settings?.followup_manager_notify_email || "",


  public_review_ask_enabled: settings?.public_review_ask_enabled !== false,


  public_review_ask_threshold: Number.isFinite(


    settings?.public_review_ask_threshold


  )


    ? Number(settings.public_review_ask_threshold)


    : DEFAULT_FORM.public_review_ask_threshold,


  public_review_ask_mode: settings?.public_review_ask_mode || "immediate",


  public_review_ask_delay_hours: Number.isFinite(


    settings?.public_review_ask_delay_hours


  )


    ? Number(settings.public_review_ask_delay_hours)


    : DEFAULT_FORM.public_review_ask_delay_hours,


  public_review_ask_require_comment: Boolean(


    settings?.public_review_ask_require_comment


  ),


  public_review_ask_min_feedback_length: Number.isFinite(
    settings?.public_review_ask_min_feedback_length
  )
    ? Number(settings.public_review_ask_min_feedback_length)
    : DEFAULT_FORM.public_review_ask_min_feedback_length,
  public_review_ask_cta_text:
    settings?.public_review_ask_cta_text ||
    DEFAULT_FORM.public_review_ask_cta_text,
  public_review_ask_helper_text:
    settings?.public_review_ask_helper_text ||
    DEFAULT_FORM.public_review_ask_helper_text,
  public_review_ask_ab_test_enabled: false,
  public_review_ask_variant_a_subject:


    settings?.public_review_ask_variant_a_subject ||


    DEFAULT_FORM.public_review_ask_variant_a_subject,


  public_review_ask_variant_a_body:


    settings?.public_review_ask_variant_a_body ||


    DEFAULT_FORM.public_review_ask_variant_a_body,


  public_review_ask_variant_b_subject: settings?.public_review_ask_variant_b_subject || "",


  public_review_ask_variant_b_body: settings?.public_review_ask_variant_b_body || "",


  public_review_ask_variant_split_pct: Number.isFinite(


    settings?.public_review_ask_variant_split_pct


  )


    ? Number(settings.public_review_ask_variant_split_pct)


    : DEFAULT_FORM.public_review_ask_variant_split_pct,


  feedback_first_enabled: settings?.feedback_first_enabled !== false,


  csat_goal_enabled: settings?.csat_goal_enabled !== false,


  csat_goal_target_rating: Number.isFinite(settings?.csat_goal_target_rating)


    ? Number(settings.csat_goal_target_rating)


    : DEFAULT_FORM.csat_goal_target_rating,


  csat_goal_target_reviews_per_week: Number.isFinite(


    settings?.csat_goal_target_reviews_per_week


  )


    ? Number(settings.csat_goal_target_reviews_per_week)


    : DEFAULT_FORM.csat_goal_target_reviews_per_week,


  google_review_url: settings?.google_review_url || "",


  review_notify_email: settings?.review_notify_email || "",


});






export default function ClientReviews() {


  const navigate = useNavigate();


  const { token, user } = useAuth();


  const storedToken = token;
  const salonId = getCurrentSalonId(user);


  const salonName = getCurrentSalonName(user);





  const [loading, setLoading] = useState(true);


  const [saving, setSaving] = useState(false);


  const [error, setError] = useState("");


  const [success, setSuccess] = useState("");


  const [form, setForm] = useState(DEFAULT_FORM);


  const [salonUsers, setSalonUsers] = useState([]);


  const [salonUsersLoading, setSalonUsersLoading] = useState(false);
  const [isGuideOpen, setIsGuideOpen] = useState(false);
  const [activeField, setActiveField] = useState(null);
  const [previewAsPortalBooking, setPreviewAsPortalBooking] = useState(true);
  const subjectRef = useRef(null);


  const bodyRef = useRef(null);






  const renderLabelWithTooltip = (labelText, tooltipKey) => (


    <span className="inline-flex items-center gap-2">


      <span>{labelText}</span>


      <InfoTooltip text={reviewTooltips[tooltipKey]} label={labelText} />


    </span>


  );





  const sampleValues = useMemo(


    () => {


      const feedbackUrl = "https://example.com/f/ABC123";


      const publicUrl = form.google_review_url || "https://example.com/review";


      return {


        client_first_name: "Alex",


        salon_name: salonName || "Your Salon",


        salon_phone: "(555) 123-4567",


        review_url: form.feedback_first_enabled ? feedbackUrl : publicUrl,


        feedback_url: feedbackUrl,


        ticket_number: "T-20260204-001",


        service_date: new Date().toLocaleDateString("en-US", {


          month: "short",


          day: "numeric",


          year: "numeric",


        }),


        signature_name: salonName || "Your Salon",


        unsubscribe_url: "https://example.com/unsubscribe",


      };


    },


    [form.google_review_url, form.feedback_first_enabled, salonName]


  );





  const resolvedSubjectTemplate = form.review_email_template_enabled


    ? form.review_email_subject || DEFAULT_FORM.review_email_subject


    : DEFAULT_FORM.review_email_subject;


  const resolvedBodyTemplate = form.review_email_template_enabled


    ? form.review_email_body || DEFAULT_FORM.review_email_body


    : DEFAULT_FORM.review_email_body;





  const previewSubject = replaceTokens(resolvedSubjectTemplate, sampleValues);


  const previewBodyHtml = useMemo(() => {


    const replaced = replaceTokens(resolvedBodyTemplate, sampleValues);


    return escapeHtml(replaced).replace(/\n/g, "<br />");


  }, [resolvedBodyTemplate, sampleValues]);





  const previewFeedbackUrl = useMemo(() => {
    if (typeof window === "undefined") return "";
    const params = new URLSearchParams({
      salon_name: salonName || "Your Salon",
      technician_name: SAMPLE_FEEDBACK_TECHNICIAN,
      service_name: SAMPLE_FEEDBACK_SERVICE,
      form_title: form.review_form_title || DEFAULT_FORM.review_form_title,
      form_subtitle:
        form.review_form_subtitle || DEFAULT_FORM.review_form_subtitle,
      comment_enabled: form.review_comment_enabled ? "1" : "0",
      comment_label: form.review_comment_label || DEFAULT_FORM.review_comment_label,
      comment_required_below_rating: String(
        form.review_comment_required_below_rating ||
          DEFAULT_FORM.review_comment_required_below_rating
      ),
      comment_required_message:
        form.review_comment_required_message ||
        DEFAULT_FORM.review_comment_required_message,
      thank_you_title:
        form.review_thank_you_title || DEFAULT_FORM.review_thank_you_title,
      thank_you_message:
        form.review_thank_you_message || DEFAULT_FORM.review_thank_you_message,
      public_review_cta_text:
        form.public_review_ask_cta_text ||
        DEFAULT_FORM.public_review_ask_cta_text,
      public_review_helper_text:
        form.public_review_ask_helper_text ||
        DEFAULT_FORM.public_review_ask_helper_text,
      google_review_url: form.google_review_url || "",
      public_review_enabled: form.public_review_ask_enabled ? "1" : "0",
      public_review_threshold: String(form.public_review_ask_threshold || 4),
      public_review_mode: form.public_review_ask_mode || "immediate",
      booked_via_portal: previewAsPortalBooking ? "1" : "0",
      question_config: JSON.stringify(
        normalizeReviewQuestionConfig(form.review_question_config)
      ),
    });
    return `${window.location.origin}/portal/review-preview?${params.toString()}`;
  }, [
    form.google_review_url,
    form.public_review_ask_enabled,
    form.public_review_ask_cta_text,
    form.public_review_ask_helper_text,
    form.public_review_ask_mode,
    form.public_review_ask_threshold,
    form.review_comment_enabled,
    form.review_comment_label,
    form.review_comment_required_below_rating,
    form.review_comment_required_message,
    form.review_form_subtitle,
    form.review_form_title,
    form.review_question_config,
    form.review_thank_you_message,
    form.review_thank_you_title,
    previewAsPortalBooking,
    salonName,
  ]);


  const handleOpenFeedbackPreview = () => {
    if (!previewFeedbackUrl || typeof window === "undefined") return;
    window.open(previewFeedbackUrl, "_blank", "noopener");
  };

  const handleCopyFeedbackPreviewLink = () => {
    if (!previewFeedbackUrl || typeof navigator === "undefined") return;
    navigator.clipboard?.writeText(previewFeedbackUrl).catch(() => {});
  };

  const updateReviewQuestion = (key, updates) => {
    setForm((prev) => {
      const current = normalizeReviewQuestionConfig(prev.review_question_config);
      const next = {
        ...current,
        [key]: {
          ...current[key],
          ...updates,
        },
      };
      if (next[key]?.locked) {
        next[key].enabled = true;
        next[key].required = true;
      }
      if (next[key]?.required) {
        next[key].enabled = true;
      }
      return {
        ...prev,
        review_question_config: normalizeReviewQuestionConfig(next),
      };
    });
  };

  const getScrollableParent = (element) => {
    if (typeof window === "undefined" || !element) return null;
    let current = element.parentElement;
    while (current && current !== document.body) {
      const { overflowY } = window.getComputedStyle(current);
      if (
        /(auto|scroll|overlay)/.test(overflowY) &&
        current.scrollHeight > current.clientHeight
      ) {
        return current;
      }
      current = current.parentElement;
    }
    return document.scrollingElement || document.documentElement;
  };

  const scrollToReviewSection = (sectionId) => {
    if (typeof window === "undefined") return;
    const target = document.getElementById(sectionId);
    if (!target) return;

    const scrollParent = getScrollableParent(target);
    if (!scrollParent) {
      target.scrollIntoView({ behavior: "smooth", block: "start" });
      return;
    }

    const scrollOnce = (behavior = "smooth") => {
      const parentRect = scrollParent.getBoundingClientRect();
      const targetRect = target.getBoundingClientRect();
      const top = targetRect.top - parentRect.top + scrollParent.scrollTop - 16;
      scrollParent.scrollTo({
        top: Math.max(0, top),
        behavior,
      });
    };

    scrollOnce();
    window.setTimeout(() => scrollOnce("auto"), 100);
  };

  const handleQuickLinkClick = (event, sectionId) => {
    event.preventDefault();
    if (typeof window !== "undefined") {
      window.history.pushState(null, "", `#${sectionId}`);
    }
    scrollToReviewSection(sectionId);
  };


  const handleTokenInsert = (tokenValue) => {
    if (!tokenValue) return;


    const target =


      activeField === "body" ? bodyRef.current : subjectRef.current;


    const canInsert =


      form.review_email_template_enabled &&


      target &&


      typeof target.selectionStart === "number";


    if (canInsert) {


      const start = target.selectionStart;


      const end = target.selectionEnd ?? start;


      if (activeField === "body") {


        setForm((prev) => ({


          ...prev,


          review_email_body:


            prev.review_email_body.slice(0, start) +


            tokenValue +


            prev.review_email_body.slice(end),


        }));


      } else {


        setForm((prev) => ({


          ...prev,


          review_email_subject:


            prev.review_email_subject.slice(0, start) +


            tokenValue +


            prev.review_email_subject.slice(end),


        }));


      }


      requestAnimationFrame(() => {


        target.focus();


        const nextPos = start + tokenValue.length;


        target.setSelectionRange(nextPos, nextPos);


      });


    }


    if (typeof navigator !== "undefined" && navigator.clipboard) {


      navigator.clipboard.writeText(tokenValue).catch(() => {});


    }


  };






  const loadSettings = async () => {



    if (!salonId) return;



    setLoading(true);



    setError("");



    try {



      const data = await getPortalSettings(salonId, storedToken);



      const settingsData = data?.portal_settings || data || {};



      setForm(buildFormState(settingsData));



    } catch (err) {



      setError(err?.response?.data?.detail || "Unable to load review settings.");



    } finally {



      setLoading(false);



    }



  };







  useEffect(() => {



    if (!storedToken || !salonId) return;



    loadSettings();



    // eslint-disable-next-line react-hooks/exhaustive-deps



  }, [storedToken, salonId]);







  useEffect(() => {



    if (typeof window === "undefined") return;



    try {



      const stored = "false";



      if (stored === "true") {



        setIsGuideOpen(true);



      }



    } catch (err) {



      // Ignore storage errors and keep default state.



    }



  }, []);







  useEffect(() => {



    if (!storedToken || !salonId) return;



    let mounted = true;



    setSalonUsersLoading(true);



    listSalonUsers(storedToken)



      .then((data) => {



        if (!mounted) return;



        setSalonUsers(Array.isArray(data) ? data : []);



      })



      .catch(() => {



        if (!mounted) return;



        setSalonUsers([]);



      })



      .finally(() => {



        if (!mounted) return;



        setSalonUsersLoading(false);



      });



    return () => {



      mounted = false;



    };



  }, [storedToken, salonId]);







  const handleToggleGuide = () => {



    setIsGuideOpen((prev) => {



      const next = !prev;



      if (typeof window !== "undefined") {



        try {



          // Keep setup guides closed by default when users return to the page.



        } catch (err) {



          // Ignore storage errors.



        }



      }



      return next;



    });



  };







  const handleSave = async (event) => {


    event.preventDefault();


    if (!salonId) return;


    setSaving(true);


    setError("");


    setSuccess("");


    if (form.review_email_template_enabled) {


      const subjectText = String(form.review_email_subject || "").trim();


      const bodyText = String(form.review_email_body || "").trim();


      if (!subjectText || !bodyText) {


        setError(


          "Please enter a subject and message body, or turn off custom message."


        );


        setSaving(false);


        return;


      }


    }


    const payload = {


      review_email_enabled: Boolean(form.review_email_enabled),


      review_email_template_enabled: Boolean(form.review_email_template_enabled),


      review_email_subject: cleanText(form.review_email_subject),


      review_email_body: cleanText(form.review_email_body),


      review_expiry_days: toNumberOr(
        form.review_expiry_days,
        DEFAULT_FORM.review_expiry_days
      ),
      review_form_title: cleanText(form.review_form_title),
      review_form_subtitle: cleanText(form.review_form_subtitle),
      review_comment_enabled: Boolean(form.review_comment_enabled),
      review_comment_label: cleanText(form.review_comment_label),
      review_comment_required_below_rating: toNumberOr(
        form.review_comment_required_below_rating,
        DEFAULT_FORM.review_comment_required_below_rating
      ),
      review_comment_required_message: cleanText(
        form.review_comment_required_message
      ),
      review_thank_you_title: cleanText(form.review_thank_you_title),
      review_thank_you_message: cleanText(form.review_thank_you_message),
      review_question_config: normalizeReviewQuestionConfig(
        form.review_question_config
      ),
      review_send_mode: cleanText(form.review_send_mode) || "on_close",
      review_send_delay_minutes: toNumberOr(


        form.review_send_delay_minutes,


        DEFAULT_FORM.review_send_delay_minutes



      ),



      review_quiet_hours_enabled: Boolean(form.review_quiet_hours_enabled),



      review_quiet_start_local: cleanText(form.review_quiet_start_local),



      review_quiet_end_local: cleanText(form.review_quiet_end_local),



      review_reminder_enabled: Boolean(form.review_reminder_enabled),



      review_reminder_delay_days: toNumberOr(



        form.review_reminder_delay_days,



        DEFAULT_FORM.review_reminder_delay_days



      ),



      review_reminder_max_count: toNumberOr(



        form.review_reminder_max_count,



        DEFAULT_FORM.review_reminder_max_count



      ),



      review_kpi_min_reviews: toNumberOr(



        form.review_kpi_min_reviews,



        DEFAULT_FORM.review_kpi_min_reviews



      ),



      review_kpi_window_days: toNumberOr(



        form.review_kpi_window_days,



        DEFAULT_FORM.review_kpi_window_days



      ),



      review_kpi_weight_overall: toNumberOr(



        form.review_kpi_weight_overall,



        DEFAULT_FORM.review_kpi_weight_overall



      ),



      review_kpi_weight_service: toNumberOr(



        form.review_kpi_weight_service,



        DEFAULT_FORM.review_kpi_weight_service



      ),



      review_kpi_weight_staff: toNumberOr(



        form.review_kpi_weight_staff,



        DEFAULT_FORM.review_kpi_weight_staff



      ),



      review_followup_enabled: Boolean(form.review_followup_enabled),



      review_followup_threshold: toNumberOr(



        form.review_followup_threshold,



        DEFAULT_FORM.review_followup_threshold



      ),



      review_followup_default_assignee_user_id:


        form.review_followup_default_assignee_user_id || null,


      followup_sla_enabled: Boolean(form.followup_sla_enabled),


      followup_sla_hours: toNumberOr(


        form.followup_sla_hours,


        DEFAULT_FORM.followup_sla_hours


      ),


      followup_overdue_reminder_hours: toNumberOr(


        form.followup_overdue_reminder_hours,


        DEFAULT_FORM.followup_overdue_reminder_hours


      ),


      followup_auto_assign_enabled: Boolean(form.followup_auto_assign_enabled),


      followup_manager_notify_email: cleanText(form.followup_manager_notify_email),


      public_review_ask_enabled: Boolean(form.public_review_ask_enabled),


      public_review_ask_threshold: toNumberOr(


        form.public_review_ask_threshold,


        DEFAULT_FORM.public_review_ask_threshold


      ),


      public_review_ask_mode: cleanText(form.public_review_ask_mode) || "immediate",


      public_review_ask_delay_hours: toNumberOr(


        form.public_review_ask_delay_hours,


        DEFAULT_FORM.public_review_ask_delay_hours


      ),


      public_review_ask_require_comment: Boolean(form.public_review_ask_require_comment),


      public_review_ask_min_feedback_length: toNumberOr(
        form.public_review_ask_min_feedback_length,
        DEFAULT_FORM.public_review_ask_min_feedback_length
      ),
      public_review_ask_cta_text: cleanText(form.public_review_ask_cta_text),
      public_review_ask_helper_text: cleanText(
        form.public_review_ask_helper_text
      ),
      public_review_ask_ab_test_enabled: false,
      public_review_ask_variant_a_subject: cleanText(form.public_review_ask_variant_a_subject),


      public_review_ask_variant_a_body: cleanText(form.public_review_ask_variant_a_body),


      public_review_ask_variant_b_subject: null,
      public_review_ask_variant_b_body: null,
      public_review_ask_variant_split_pct:
        DEFAULT_FORM.public_review_ask_variant_split_pct,


      feedback_first_enabled: Boolean(form.feedback_first_enabled),


      csat_goal_enabled: Boolean(form.csat_goal_enabled),


      csat_goal_target_rating: toNumberOr(


        form.csat_goal_target_rating,


        DEFAULT_FORM.csat_goal_target_rating


      ),


      csat_goal_target_reviews_per_week: toNumberOr(


        form.csat_goal_target_reviews_per_week,


        DEFAULT_FORM.csat_goal_target_reviews_per_week


      ),


      google_review_url: cleanText(form.google_review_url),


      review_notify_email: cleanText(form.review_notify_email),


    };






    try {



      const updated = await updatePortalSettings(salonId, payload, storedToken);



      const settingsData = updated?.portal_settings || updated || {};



      setForm(buildFormState(settingsData));



      setSuccess("Client review settings updated.");



    } catch (err) {



      setError(err?.response?.data?.detail || "Unable to save review settings.");



    } finally {



      setSaving(false);



    }



  };







  const modalText = "text-sm md:text-base";





  const handleClose = (event) => {


    event?.preventDefault?.();


    event?.stopPropagation?.();


    if (typeof window !== "undefined" && window.history.length > 1) {


      navigate(-1);


      return;


    }


    navigate("/manager/schedule");


  };





  return (


    <div className="marketingSectionShell">
      <div
        className={`marketingSectionWide marketing-section-wide marketing-section-compact ${modalText}`}
      >
        <div className="rounded-3xl border border-slate-200 bg-white shadow-2xl overflow-hidden">


          <div className="bg-rose-500 px-6 py-4 relative">


            <h1 className="text-xl md:text-2xl font-semibold text-white">


              Client Reviews


            </h1>


            <div


              className="absolute right-4 top-3 z-50"


              onClick={handleClose}


              onMouseDown={(event) => {


                event.preventDefault();


                event.stopPropagation();


              }}


            >


              <ModalCloseX onClick={handleClose} />


            </div>


          </div>


          <div className="px-6 py-6 space-y-6">



            <div className="rounded-2xl border border-slate-200 bg-white shadow-sm p-5">



              <div className="flex items-center justify-between gap-3">



                <div className="text-base md:text-lg font-semibold text-slate-900">



                  How to set up Client Reviews



                </div>



                <button



                  type="button"



                  onClick={handleToggleGuide}



                  aria-expanded={isGuideOpen}



                  aria-controls={GUIDE_BODY_ID}



                  className="rounded-full border border-slate-300 px-4 py-2 text-xs md:text-sm font-semibold text-slate-700 hover:bg-slate-50"



                >



                  {isGuideOpen ? "Hide setup guide" : "Show setup guide"}



                </button>



              </div>



              {!isGuideOpen && (



                <p className="mt-2 text-sm text-slate-500">



                  Follow these steps to set up client review emails.



                </p>



              )}



              <div



                id={GUIDE_BODY_ID}



                hidden={!isGuideOpen}



                aria-hidden={!isGuideOpen}



                className="mt-4 space-y-4"



              >



                <ol className="list-decimal pl-5 space-y-3 text-sm text-slate-600">



                  {reviewSetupGuideSteps.map((step) => (



                    <li key={step.title} className="space-y-2">



                      <div className="text-sm font-semibold text-slate-800">



                        {step.title}



                      </div>



                      <div className="text-sm text-slate-600">{step.body}</div>



                      {Array.isArray(step.lines) && step.lines.length > 0 && (



                        <div className="space-y-1 text-sm text-slate-600">



                          {step.lines.map((line) => (



                            <div key={line} className="flex gap-2">



                              <span className="text-slate-400">-</span>



                              <span>{line}</span>



                            </div>



                          ))}



                        </div>



                      )}



                    </li>



                  ))}



                </ol>



                <div className="text-xs text-slate-500">



                  {reviewSetupGuideNote}



                </div>



              </div>



            </div>







            <div className="rounded-2xl border border-slate-200 bg-white p-4 shadow-sm">
              <div className="text-xs font-semibold uppercase tracking-wide text-slate-500">
                Quick links
              </div>
              <div className="mt-3 flex flex-wrap gap-2">
                {CLIENT_REVIEW_SECTION_LINKS.map(([sectionId, label]) => (
                  <a
                    key={sectionId}
                    href={`#${sectionId}`}
                    onClick={(event) => handleQuickLinkClick(event, sectionId)}
                    className="rounded-full border border-slate-300 px-3 py-2 text-xs md:text-sm font-semibold text-slate-700 hover:bg-slate-50"
                  >
                    {label}
                  </a>
                ))}
              </div>
            </div>



            {error && (
              <div className="rounded-2xl border border-rose-200 bg-rose-50 px-4 py-3 text-sm text-rose-700">



                {error}



              </div>



            )}



            {success && (



              <div className="rounded-2xl border border-emerald-200 bg-emerald-50 px-4 py-3 text-sm text-emerald-700">



                {success}



              </div>



            )}







            {loading ? (



              <div className="rounded-2xl border border-slate-200 bg-white px-4 py-3 text-sm text-slate-600">



                Loading review settings...



              </div>



            ) : (



              <form
                onSubmit={handleSave}
                className="flex flex-col gap-6 lg:grid lg:grid-cols-[minmax(0,1.35fr)_minmax(380px,0.9fr)] lg:items-start"
              >
                <div
                  id="client-review-preview"
                  className="order-2 scroll-mt-24 lg:col-start-2 lg:row-start-1 lg:self-start"
                >
                  <ClientFeedbackLivePreview
                    form={form}
                    salonName={salonName}
                    onOpenPreview={handleOpenFeedbackPreview}
                    previewFeedbackUrl={previewFeedbackUrl}
                    previewAsPortalBooking={previewAsPortalBooking}
                    onPreviewAsPortalBookingChange={setPreviewAsPortalBooking}
                    onCopyPreviewLink={handleCopyFeedbackPreviewLink}
                  />
                </div>
                <div className="order-1 flex flex-col gap-6 lg:col-start-1 lg:row-start-1">
                <div id="client-review-copy" className="order-3 rounded-2xl border border-slate-200 bg-white p-6 space-y-5 scroll-mt-24">
                  <div className="flex flex-wrap items-start justify-between gap-3">
                    <div>
                      <h2 className="text-lg md:text-xl font-semibold text-slate-900">
                        Feedback form copy
                      </h2>
                      <p className="text-sm text-slate-500">
                        Customize the title and message clients see at the top of
                        the feedback form.
                      </p>
                    </div>
                    <SaveChangesButton saving={saving} />
                  </div>
                  <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
                    <label className="block space-y-2">
                      <span className="text-xs font-semibold uppercase text-slate-500">
                        Title
                      </span>
                      <input
                        type="text"
                        value={form.review_form_title}
                        onChange={(event) =>
                          setForm((prev) => ({
                            ...prev,
                            review_form_title: event.target.value,
                          }))
                        }
                        className="w-full rounded-xl border border-slate-300 px-4 py-3 text-sm md:text-base"
                        placeholder={DEFAULT_FORM.review_form_title}
                      />
                    </label>
                    <label className="block space-y-2">
                      <span className="text-xs font-semibold uppercase text-slate-500">
                        Subtitle
                      </span>
                      <input
                        type="text"
                        value={form.review_form_subtitle}
                        onChange={(event) =>
                          setForm((prev) => ({
                            ...prev,
                            review_form_subtitle: event.target.value,
                          }))
                        }
                        className="w-full rounded-xl border border-slate-300 px-4 py-3 text-sm md:text-base"
                        placeholder={DEFAULT_FORM.review_form_subtitle}
                      />
                    </label>
                  </div>
                </div>
                <div id="client-review-questions" className="order-3 rounded-2xl border border-slate-200 bg-white p-6 space-y-5 scroll-mt-24">
                  <div className="flex flex-wrap items-start justify-between gap-3">
                    <div>
                      <h2 className="text-lg md:text-xl font-semibold text-slate-900">
                        Feedback questions
                      </h2>
                      <p className="text-sm text-slate-500">
                        Rename questions and choose which ones clients must answer.
                      </p>
                    </div>
                    <SaveChangesButton saving={saving} />
                  </div>
                  <div className="space-y-3">
                    {Object.entries(
                      normalizeReviewQuestionConfig(form.review_question_config)
                    ).map(([key, question]) => {
                      const isTechnician = key.startsWith("technician_");
                      return (
                        <div
                          key={key}
                          className="rounded-2xl border border-slate-200 bg-slate-50 p-4 space-y-3"
                        >
                          <div className="flex flex-wrap items-center justify-between gap-3">
                            <div className="text-sm font-semibold text-slate-700">
                              {isTechnician
                                ? "Technician question"
                                : "Visit question"}
                            </div>
                            <div className="flex flex-wrap items-center gap-4 text-sm text-slate-700">
                              <label className="inline-flex items-center gap-2">
                                <input
                                  type="checkbox"
                                  checked={question.enabled}
                                  disabled={question.locked || question.required}
                                  onChange={(event) =>
                                    updateReviewQuestion(key, {
                                      enabled: event.target.checked,
                                    })
                                  }
                                  className="h-4 w-4 rounded border-slate-300 text-slate-900"
                                />
                                <span>Enabled</span>
                              </label>
                              <label className="inline-flex items-center gap-2">
                                <input
                                  type="checkbox"
                                  checked={question.required}
                                  disabled={question.locked}
                                  onChange={(event) =>
                                    updateReviewQuestion(key, {
                                      required: event.target.checked,
                                    })
                                  }
                                  className="h-4 w-4 rounded border-slate-300 text-slate-900"
                                />
                                <span>Required</span>
                              </label>
                            </div>
                          </div>
                          <label className="block space-y-2">
                            <span className="text-xs font-semibold uppercase text-slate-500">
                              Question label
                            </span>
                            <input
                              type="text"
                              value={question.label}
                              onChange={(event) =>
                                updateReviewQuestion(key, {
                                  label: event.target.value,
                                })
                              }
                              className="w-full rounded-xl border border-slate-300 px-4 py-3 text-sm md:text-base"
                            />
                          </label>
                          {question.locked && (
                            <div className="text-xs text-slate-500">
                              Overall experience stays required because it drives the
                              review score, alerts, and public review rules.
                            </div>
                          )}
                        </div>
                      );
                    })}
                  </div>
                </div>
                <div id="client-review-comments" className="order-3 rounded-2xl border border-slate-200 bg-white p-6 space-y-5 scroll-mt-24">
                  <div className="flex flex-wrap items-start justify-between gap-3">
                    <div>
                      <h2 className="text-lg md:text-xl font-semibold text-slate-900">
                        Comment rules
                      </h2>
                      <p className="text-sm text-slate-500">
                        Control the optional comment box and when it becomes required.
                      </p>
                    </div>
                    <SaveChangesButton saving={saving} />
                  </div>
                  <label className="flex items-center gap-3 text-sm text-slate-700">
                    <input
                      type="checkbox"
                      checked={!!form.review_comment_enabled}
                      onChange={(event) =>
                        setForm((prev) => ({
                          ...prev,
                          review_comment_enabled: event.target.checked,
                        }))
                      }
                      className="h-4 w-4 rounded border-slate-300 text-slate-900"
                    />
                    <span className="font-semibold">Enable comment box</span>
                  </label>
                  <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
                    <label className="block space-y-2">
                      <span className="text-xs font-semibold uppercase text-slate-500">
                        Label
                      </span>
                      <input
                        type="text"
                        value={form.review_comment_label}
                        onChange={(event) =>
                          setForm((prev) => ({
                            ...prev,
                            review_comment_label: event.target.value,
                          }))
                        }
                        disabled={!form.review_comment_enabled}
                        className="w-full rounded-xl border border-slate-300 px-4 py-3 text-sm md:text-base disabled:bg-slate-100"
                      />
                    </label>
                    <label className="block space-y-2">
                      <span className="text-xs font-semibold uppercase text-slate-500">
                        Required below
                      </span>
                      <select
                        value={form.review_comment_required_below_rating}
                        onChange={(event) =>
                          setForm((prev) => ({
                            ...prev,
                            review_comment_required_below_rating:
                              event.target.value,
                          }))
                        }
                        disabled={!form.review_comment_enabled}
                        className="h-12 w-full rounded-xl border border-slate-300 px-4 bg-white disabled:bg-slate-100"
                      >
                        {[2, 3, 4, 5].map((value) => (
                          <option key={value} value={value}>
                            Below {value}
                          </option>
                        ))}
                      </select>
                    </label>
                  </div>
                  <label className="block space-y-2">
                    <span className="text-xs font-semibold uppercase text-slate-500">
                      Required message
                    </span>
                    <input
                      type="text"
                      value={form.review_comment_required_message}
                      onChange={(event) =>
                        setForm((prev) => ({
                          ...prev,
                          review_comment_required_message: event.target.value,
                        }))
                      }
                      disabled={!form.review_comment_enabled}
                      className="w-full rounded-xl border border-slate-300 px-4 py-3 text-sm md:text-base disabled:bg-slate-100"
                    />
                  </label>
                </div>
                <div id="client-review-thank-you" className="order-3 rounded-2xl border border-slate-200 bg-white p-6 space-y-5 scroll-mt-24">
                  <div className="flex flex-wrap items-start justify-between gap-3">
                    <div>
                      <h2 className="text-lg md:text-xl font-semibold text-slate-900">
                        Thank-you screen
                      </h2>
                      <p className="text-sm text-slate-500">
                        Customize the confirmation clients see after submitting feedback.
                      </p>
                    </div>
                    <SaveChangesButton saving={saving} />
                  </div>
                  <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
                    <label className="block space-y-2">
                      <span className="text-xs font-semibold uppercase text-slate-500">
                        Title
                      </span>
                      <input
                        type="text"
                        value={form.review_thank_you_title}
                        onChange={(event) =>
                          setForm((prev) => ({
                            ...prev,
                            review_thank_you_title: event.target.value,
                          }))
                        }
                        className="w-full rounded-xl border border-slate-300 px-4 py-3 text-sm md:text-base"
                      />
                    </label>
                    <label className="block space-y-2">
                      <span className="text-xs font-semibold uppercase text-slate-500">
                        Message
                      </span>
                      <input
                        type="text"
                        value={form.review_thank_you_message}
                        onChange={(event) =>
                          setForm((prev) => ({
                            ...prev,
                            review_thank_you_message: event.target.value,
                          }))
                        }
                        className="w-full rounded-xl border border-slate-300 px-4 py-3 text-sm md:text-base"
                      />
                    </label>
                  </div>
                </div>
                <div id="client-review-public-cta" className="order-3 rounded-2xl border border-slate-200 bg-white p-6 space-y-5 scroll-mt-24">
                  <div className="flex flex-wrap items-start justify-between gap-3">
                    <div>
                      <h2 className="text-lg md:text-xl font-semibold text-slate-900">
                        Public review CTA
                      </h2>
                      <p className="text-sm text-slate-500">
                        Customize the public review ask shown after positive feedback.
                      </p>
                    </div>
                    <SaveChangesButton saving={saving} />
                  </div>
                  <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
                    <label className="block space-y-2">
                      <span className="text-xs font-semibold uppercase text-slate-500">
                        CTA text
                      </span>
                      <input
                        type="text"
                        value={form.public_review_ask_cta_text}
                        onChange={(event) =>
                          setForm((prev) => ({
                            ...prev,
                            public_review_ask_cta_text: event.target.value,
                          }))
                        }
                        className="w-full rounded-xl border border-slate-300 px-4 py-3 text-sm md:text-base"
                      />
                    </label>
                    <label className="block space-y-2">
                      <span className="text-xs font-semibold uppercase text-slate-500">
                        Helper text
                      </span>
                      <input
                        type="text"
                        value={form.public_review_ask_helper_text}
                        onChange={(event) =>
                          setForm((prev) => ({
                            ...prev,
                            public_review_ask_helper_text: event.target.value,
                          }))
                        }
                        className="w-full rounded-xl border border-slate-300 px-4 py-3 text-sm md:text-base"
                      />
                    </label>
                  </div>
                </div>
                <div id="client-review-settings" className="order-1 rounded-2xl border border-slate-200 bg-white p-6 space-y-6 scroll-mt-24">
                  <div className="flex flex-wrap items-start justify-between gap-3">
                    <div>
                    <h2 className="text-lg md:text-xl font-semibold text-slate-900">



                      Client Reviews



                    </h2>



                    <p className="text-sm text-slate-500">



                      Manage review requests and follow-up alerts.



                    </p>



                    </div>
                    <SaveChangesButton saving={saving} />
                  </div>




                  <label className="flex items-center gap-3 text-sm md:text-base text-slate-700">


                    <input


                      type="checkbox"


                      checked={!!form.review_email_enabled}


                      onChange={(e) =>



                        setForm((prev) => ({



                          ...prev,



                          review_email_enabled: e.target.checked,



                        }))



                      }


                      className="h-4 w-4 rounded border-slate-300 text-slate-900"


                    />


                    <span className="font-semibold text-slate-700">


                      {renderLabelWithTooltip(


                        "Enable review emails",


                        "review_email_enabled"


                      )}


                    </span>


                  </label>


                  <p className="text-xs text-slate-500">


                    {reviewFieldHelp.review_email_enabled}


                  </p>






                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">



                    <div className="space-y-2">


                      <label className="text-sm md:text-base font-semibold tracking-wide text-slate-500">


                        {renderLabelWithTooltip("Send mode", "review_send_mode")}


                      </label>


                      <select


                        value={form.review_send_mode}


                        onChange={(e) =>


                          setForm((prev) => ({



                            ...prev,



                            review_send_mode: e.target.value,



                          }))



                        }



                        className="h-11 md:h-12 w-full rounded-xl border border-slate-300 px-4 bg-white"



                      >



                        <option value="on_close">On ticket close</option>



                        <option value="delayed">Delayed</option>



                      </select>



                      <p className="text-xs text-slate-500">



                        {reviewFieldHelp.review_send_mode}



                      </p>



                    </div>


                    <div className="space-y-2">


                      <label className="text-sm md:text-base font-semibold tracking-wide text-slate-500">


                        {renderLabelWithTooltip(


                          "Delay minutes",


                          "review_send_delay_minutes"


                        )}


                      </label>


                      <input


                        type="number"


                        min={0}


                        step={1}



                        value={form.review_send_delay_minutes}



                        onChange={(e) =>



                          setForm((prev) => ({



                            ...prev,



                            review_send_delay_minutes: e.target.value,



                          }))



                        }



                        disabled={form.review_send_mode !== "delayed"}



                        className="h-11 md:h-12 w-full rounded-xl border border-slate-300 px-4 disabled:bg-slate-100"



                      />



                      <p className="text-xs text-slate-500">



                        {reviewFieldHelp.review_send_delay_minutes}



                      </p>



                    </div>



                  </div>







                    <div className="space-y-2">
                      <label className="text-sm md:text-base font-semibold tracking-wide text-slate-500">
                        Feedback expiry days
                      </label>
                      <input
                        type="number"
                        min={1}
                        max={60}
                        step={1}
                        value={form.review_expiry_days}
                        onChange={(e) =>
                          setForm((prev) => ({
                            ...prev,
                            review_expiry_days: e.target.value,
                          }))
                        }
                        className="h-11 md:h-12 w-full rounded-xl border border-slate-300 px-4"
                      />
                      <p className="text-xs text-slate-500">
                        Feedback links expire after this many days.
                      </p>
                    </div>


                  <div className="space-y-3">
                    <label className="flex items-center gap-3 text-sm md:text-base text-slate-700">


                      <input


                        type="checkbox"


                        checked={!!form.review_quiet_hours_enabled}


                        onChange={(e) =>



                          setForm((prev) => ({



                            ...prev,



                            review_quiet_hours_enabled: e.target.checked,



                          }))



                        }


                        className="h-4 w-4 rounded border-slate-300 text-slate-900"


                      />


                      <span className="font-semibold text-slate-700">


                        {renderLabelWithTooltip(


                          "Quiet hours",


                          "review_quiet_hours_enabled"


                        )}


                      </span>


                    </label>


                    <p className="text-xs text-slate-500">


                      {reviewFieldHelp.review_quiet_hours_enabled}


                    </p>


                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">


                      <div className="space-y-2">


                        <label className="text-sm md:text-base font-semibold tracking-wide text-slate-500">


                          {renderLabelWithTooltip(


                            "Quiet start",


                            "review_quiet_start_local"


                          )}


                        </label>


                        <TimeSelect


                          value={form.review_quiet_start_local}


                          onChange={(value) =>


                            setForm((prev) => ({


                              ...prev,



                              review_quiet_start_local: value,



                            }))



                          }



                          disabled={!form.review_quiet_hours_enabled}



                        />



                        <p className="text-xs text-slate-500">



                          {reviewFieldHelp.review_quiet_start_local}



                        </p>



                      </div>


                      <div className="space-y-2">


                        <label className="text-sm md:text-base font-semibold tracking-wide text-slate-500">


                          {renderLabelWithTooltip(


                            "Quiet end",


                            "review_quiet_end_local"


                          )}


                        </label>


                        <TimeSelect


                          value={form.review_quiet_end_local}


                          onChange={(value) =>


                            setForm((prev) => ({


                              ...prev,



                              review_quiet_end_local: value,



                            }))



                          }



                          disabled={!form.review_quiet_hours_enabled}



                        />



                        <p className="text-xs text-slate-500">



                          {reviewFieldHelp.review_quiet_end_local}



                        </p>



                      </div>



                    </div>



                  </div>







                  <div className="space-y-3">


                    <label className="flex items-center gap-3 text-sm md:text-base text-slate-700">


                      <input


                        type="checkbox"


                        checked={!!form.review_reminder_enabled}


                        onChange={(e) =>



                          setForm((prev) => ({



                            ...prev,



                            review_reminder_enabled: e.target.checked,



                          }))



                        }


                        className="h-4 w-4 rounded border-slate-300 text-slate-900"


                      />


                      <span className="font-semibold text-slate-700">


                        {renderLabelWithTooltip(


                          "Enable reminders",


                          "review_reminder_enabled"


                        )}


                      </span>


                    </label>


                    <p className="text-xs text-slate-500">


                      {reviewFieldHelp.review_reminder_enabled}


                    </p>


                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">


                      <div className="space-y-2">


                        <label className="text-sm md:text-base font-semibold tracking-wide text-slate-500">


                          {renderLabelWithTooltip(


                            "Reminder delay (days)",


                            "review_reminder_delay_days"


                          )}


                        </label>


                        <input


                          type="number"


                          min={1}


                          step={1}



                          value={form.review_reminder_delay_days}



                          onChange={(e) =>



                            setForm((prev) => ({



                              ...prev,



                              review_reminder_delay_days: e.target.value,



                            }))



                          }



                          disabled={!form.review_reminder_enabled}



                          className="h-11 md:h-12 w-full rounded-xl border border-slate-300 px-4 disabled:bg-slate-100"



                        />



                        <p className="text-xs text-slate-500">



                          {reviewFieldHelp.review_reminder_delay_days}



                        </p>



                      </div>


                      <div className="space-y-2">


                        <label className="text-sm md:text-base font-semibold tracking-wide text-slate-500">


                          {renderLabelWithTooltip(


                            "Max reminders",


                            "review_reminder_max_count"


                          )}


                        </label>


                        <input


                          type="number"


                          min={0}


                          step={1}



                          value={form.review_reminder_max_count}



                          onChange={(e) =>



                            setForm((prev) => ({



                              ...prev,



                              review_reminder_max_count: e.target.value,



                            }))



                          }



                          disabled={!form.review_reminder_enabled}



                          className="h-11 md:h-12 w-full rounded-xl border border-slate-300 px-4 disabled:bg-slate-100"



                        />



                        <p className="text-xs text-slate-500">



                          {reviewFieldHelp.review_reminder_max_count}



                        </p>



                      </div>



                    </div>



                  </div>







                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">


                    <div className="space-y-2">


                      <label className="text-sm md:text-base font-semibold tracking-wide text-slate-500">


                        {renderLabelWithTooltip(


                          "Public review URL",


                          "google_review_url"


                        )}


                      </label>


                      <input


                        type="text"


                        value={form.google_review_url}


                        onChange={(e) =>



                          setForm((prev) => ({



                            ...prev,



                            google_review_url: e.target.value,



                          }))



                        }



                        placeholder="https://..."



                        className="h-11 md:h-12 w-full rounded-xl border border-slate-300 px-4"



                      />



                      <p className="text-xs text-slate-500">



                        {reviewFieldHelp.google_review_url}



                      </p>



                    </div>


                    <div className="space-y-2">


                      <label className="text-sm md:text-base font-semibold tracking-wide text-slate-500">


                        {renderLabelWithTooltip(


                          "Review alert email",


                          "review_notify_email"


                        )}


                      </label>


                      <input


                        type="email"


                        value={form.review_notify_email}


                        onChange={(e) =>



                          setForm((prev) => ({



                            ...prev,



                            review_notify_email: e.target.value,



                          }))



                        }



                        placeholder="manager@salon.com"



                        className="h-11 md:h-12 w-full rounded-xl border border-slate-300 px-4"



                      />



                      <p className="text-xs text-slate-500">


                        {reviewFieldHelp.review_notify_email}


                      </p>


                    </div>


                  </div>





                  <div className="rounded-xl border border-slate-200 bg-white p-4 space-y-3">
                    <div className="text-xs font-semibold uppercase tracking-wide text-slate-500">
                      Feedback-first


                    </div>


                    <label className="flex items-center gap-3 text-sm md:text-base text-slate-700">


                      <input


                        type="checkbox"


                        checked={!!form.feedback_first_enabled}


                        onChange={(e) =>


                          setForm((prev) => ({


                            ...prev,


                            feedback_first_enabled: e.target.checked,


                          }))


                        }


                        className="h-4 w-4 rounded border-slate-300 text-slate-900"


                      />


                      <span className="font-semibold text-slate-700">


                        {renderLabelWithTooltip(


                          "Feedback first (recommended)",


                          "feedback_first_enabled"


                        )}


                      </span>


                    </label>


                    <p className="text-xs text-slate-500">


                      {reviewFieldHelp.feedback_first_enabled}


                    </p>


                  </div>





                  <div id="client-review-public-rules" className="rounded-xl border border-slate-200 bg-white p-4 space-y-4 scroll-mt-24">
                    <div className="flex flex-wrap items-center justify-between gap-3">
                      <div className="text-xs font-semibold uppercase tracking-wide text-slate-500">
                      Public review ask


                      </div>
                      <SaveChangesButton saving={saving} />
                    </div>
                    <label className="flex items-center gap-3 text-sm md:text-base text-slate-700">


                      <input


                        type="checkbox"


                        checked={!!form.public_review_ask_enabled}


                        onChange={(e) =>


                          setForm((prev) => ({


                            ...prev,


                            public_review_ask_enabled: e.target.checked,


                          }))


                        }


                        className="h-4 w-4 rounded border-slate-300 text-slate-900"


                      />


                      <span className="font-semibold text-slate-700">


                        {renderLabelWithTooltip(


                          "Enable public review ask",


                          "public_review_ask_enabled"


                        )}


                      </span>


                    </label>


                    <p className="text-xs text-slate-500">


                      {reviewFieldHelp.public_review_ask_enabled}


                    </p>


                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">


                      <div className="space-y-2">


                        <label className="text-sm md:text-base font-semibold tracking-wide text-slate-500">


                          {renderLabelWithTooltip(


                            "Threshold (rating or above)",


                            "public_review_ask_threshold"


                          )}


                        </label>


                        <input


                          type="number"


                          min={1}


                          max={5}


                          step={1}


                          value={form.public_review_ask_threshold}


                          onChange={(e) =>


                            setForm((prev) => ({


                              ...prev,


                              public_review_ask_threshold: e.target.value,


                            }))


                          }


                          disabled={!form.public_review_ask_enabled}


                          className="h-11 md:h-12 w-full rounded-xl border border-slate-300 px-4 disabled:bg-slate-100"


                        />


                        <p className="text-xs text-slate-500">


                          {reviewFieldHelp.public_review_ask_threshold}


                        </p>


                      </div>


                      <div className="space-y-2">


                        <label className="text-sm md:text-base font-semibold tracking-wide text-slate-500">


                          {renderLabelWithTooltip(


                            "Ask mode",


                            "public_review_ask_mode"


                          )}


                        </label>


                        <select


                          value={form.public_review_ask_mode}


                          onChange={(e) =>


                            setForm((prev) => ({


                              ...prev,


                              public_review_ask_mode: e.target.value,


                            }))


                          }


                          disabled={!form.public_review_ask_enabled}


                          className="h-11 md:h-12 w-full rounded-xl border border-slate-300 px-4 bg-white disabled:bg-slate-100"


                        >


                          <option value="immediate">Immediate (thank-you screen)</option>


                          <option value="delayed_email">Delayed email</option>


                        </select>


                        <p className="text-xs text-slate-500">


                          {reviewFieldHelp.public_review_ask_mode}


                        </p>


                      </div>


                      <div className="space-y-2">


                        <label className="text-sm md:text-base font-semibold tracking-wide text-slate-500">


                          {renderLabelWithTooltip(


                            "Delay (hours)",


                            "public_review_ask_delay_hours"


                          )}


                        </label>


                        <input


                          type="number"


                          min={1}


                          step={1}


                          value={form.public_review_ask_delay_hours}


                          onChange={(e) =>


                            setForm((prev) => ({


                              ...prev,


                              public_review_ask_delay_hours: e.target.value,


                            }))


                          }


                          disabled={


                            !form.public_review_ask_enabled ||


                            form.public_review_ask_mode !== "delayed_email"


                          }


                          className="h-11 md:h-12 w-full rounded-xl border border-slate-300 px-4 disabled:bg-slate-100"


                        />


                        <p className="text-xs text-slate-500">


                          {reviewFieldHelp.public_review_ask_delay_hours}


                        </p>


                      </div>


                      <div className="space-y-2">


                        <label className="text-sm md:text-base font-semibold tracking-wide text-slate-500">


                          {renderLabelWithTooltip(


                            "Min comment length",


                            "public_review_ask_min_feedback_length"


                          )}


                        </label>


                        <input


                          type="number"


                          min={0}


                          step={1}


                          value={form.public_review_ask_min_feedback_length}


                          onChange={(e) =>


                            setForm((prev) => ({


                              ...prev,


                              public_review_ask_min_feedback_length: e.target.value,


                            }))


                          }


                          disabled={!form.public_review_ask_enabled}


                          className="h-11 md:h-12 w-full rounded-xl border border-slate-300 px-4 disabled:bg-slate-100"


                        />


                        <p className="text-xs text-slate-500">


                          {reviewFieldHelp.public_review_ask_min_feedback_length}


                        </p>


                      </div>


                    </div>


                    <label className="flex items-center gap-3 text-sm md:text-base text-slate-700">


                      <input


                        type="checkbox"


                        checked={!!form.public_review_ask_require_comment}


                        onChange={(e) =>


                          setForm((prev) => ({


                            ...prev,


                            public_review_ask_require_comment: e.target.checked,


                          }))


                        }


                        disabled={!form.public_review_ask_enabled}


                        className="h-4 w-4 rounded border-slate-300 text-slate-900"


                      />


                      <span className="font-semibold text-slate-700">


                        {renderLabelWithTooltip(


                          "Require comment",


                          "public_review_ask_require_comment"


                        )}


                      </span>


                    </label>


                    <p className="text-xs text-slate-500">


                      {reviewFieldHelp.public_review_ask_require_comment}


                    </p>


                    <div className="text-xs text-slate-500">


                      Tokens: {"{{client_first_name}}"}, {"{{salon_name}}"},{" "}


                      {"{{public_review_link}}"}


                    </div>


                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">


                      <div className="space-y-2">


                        <label className="text-sm md:text-base font-semibold tracking-wide text-slate-500">


                          {renderLabelWithTooltip(


                            "Email subject",
                            "public_review_ask_variant_a_subject"


                          )}


                        </label>


                        <input


                          type="text"


                          value={form.public_review_ask_variant_a_subject}


                          onChange={(e) =>


                            setForm((prev) => ({


                              ...prev,


                              public_review_ask_variant_a_subject: e.target.value,


                            }))


                          }


                          className="h-11 md:h-12 w-full rounded-xl border border-slate-300 px-4"


                        />


                      </div>


                      <div className="space-y-2">


                        <label className="text-sm md:text-base font-semibold tracking-wide text-slate-500">


                          {renderLabelWithTooltip(


                            "Email body",
                            "public_review_ask_variant_a_body"


                          )}


                        </label>


                        <textarea


                          rows={4}


                          value={form.public_review_ask_variant_a_body}


                          onChange={(e) =>


                            setForm((prev) => ({


                              ...prev,


                              public_review_ask_variant_a_body: e.target.value,


                            }))


                          }


                          className="w-full rounded-xl border border-slate-300 px-4 py-3 text-sm"


                        />


                      </div>


                    </div>




                  </div>





                  <div className="rounded-xl border border-slate-200 bg-white p-4 space-y-3">


                    <div className="text-xs font-semibold uppercase tracking-wide text-slate-500">


                      <span id="client-review-kpis" className="scroll-mt-24">KPI rules</span>
                      <div className="mt-3">
                        <SaveChangesButton saving={saving} />
                      </div>
                    </div>


                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">


                      <div className="space-y-2">


                        <label className="text-sm md:text-base font-semibold tracking-wide text-slate-500">


                          {renderLabelWithTooltip(


                            "Min reviews",


                            "review_kpi_min_reviews"


                          )}


                        </label>


                        <input


                          type="number"


                          min={1}


                          step={1}


                          value={form.review_kpi_min_reviews}


                          onChange={(e) =>


                            setForm((prev) => ({


                              ...prev,


                              review_kpi_min_reviews: e.target.value,


                            }))


                          }


                          className="h-11 md:h-12 w-full rounded-xl border border-slate-300 px-4"


                        />


                        <p className="text-xs text-slate-500">


                          {reviewFieldHelp.review_kpi_min_reviews}


                        </p>


                      </div>


                      <div className="space-y-2">


                        <label className="text-sm md:text-base font-semibold tracking-wide text-slate-500">


                          {renderLabelWithTooltip(


                            "Window (days)",


                            "review_kpi_window_days"


                          )}


                        </label>


                        <input


                          type="number"


                          min={1}


                          step={1}


                          value={form.review_kpi_window_days}


                          onChange={(e) =>


                            setForm((prev) => ({


                              ...prev,


                              review_kpi_window_days: e.target.value,


                            }))


                          }


                          className="h-11 md:h-12 w-full rounded-xl border border-slate-300 px-4"


                        />


                        <p className="text-xs text-slate-500">


                          {reviewFieldHelp.review_kpi_window_days}


                        </p>


                      </div>


                      <div className="space-y-2">


                        <label className="text-sm md:text-base font-semibold tracking-wide text-slate-500">


                          {renderLabelWithTooltip(


                            "Weight: overall",


                            "review_kpi_weight_overall"


                          )}


                        </label>


                        <input


                          type="number"


                          min={0}


                          max={100}


                          step={1}


                          value={form.review_kpi_weight_overall}


                          onChange={(e) =>


                            setForm((prev) => ({


                              ...prev,


                              review_kpi_weight_overall: e.target.value,


                            }))


                          }


                          className="h-11 md:h-12 w-full rounded-xl border border-slate-300 px-4"


                        />


                        <p className="text-xs text-slate-500">


                          {reviewFieldHelp.review_kpi_weight_overall}


                        </p>


                      </div>


                      <div className="space-y-2">


                        <label className="text-sm md:text-base font-semibold tracking-wide text-slate-500">


                          {renderLabelWithTooltip(


                            "Weight: service",


                            "review_kpi_weight_service"


                          )}


                        </label>


                        <input


                          type="number"


                          min={0}


                          max={100}


                          step={1}


                          value={form.review_kpi_weight_service}


                          onChange={(e) =>


                            setForm((prev) => ({


                              ...prev,


                              review_kpi_weight_service: e.target.value,


                            }))


                          }


                          className="h-11 md:h-12 w-full rounded-xl border border-slate-300 px-4"


                        />


                        <p className="text-xs text-slate-500">


                          {reviewFieldHelp.review_kpi_weight_service}


                        </p>


                      </div>


                      <div className="space-y-2">


                        <label className="text-sm md:text-base font-semibold tracking-wide text-slate-500">


                          {renderLabelWithTooltip(


                            "Weight: staff",


                            "review_kpi_weight_staff"


                          )}


                        </label>


                        <input


                          type="number"


                          min={0}


                          max={100}


                          step={1}


                          value={form.review_kpi_weight_staff}


                          onChange={(e) =>


                            setForm((prev) => ({


                              ...prev,


                              review_kpi_weight_staff: e.target.value,


                            }))


                          }


                          className="h-11 md:h-12 w-full rounded-xl border border-slate-300 px-4"


                        />


                        <p className="text-xs text-slate-500">


                          {reviewFieldHelp.review_kpi_weight_staff}


                        </p>


                      </div>


                    </div>


                  </div>





                  <div className="rounded-xl border border-slate-200 bg-white p-4 space-y-3">


                    <div className="text-xs font-semibold uppercase tracking-wide text-slate-500">


                      Customer Satisfaction Goals


                    </div>


                    <label className="flex items-center gap-3 text-sm md:text-base text-slate-700">


                      <input


                        type="checkbox"


                        checked={!!form.csat_goal_enabled}


                        onChange={(e) =>


                          setForm((prev) => ({


                            ...prev,


                            csat_goal_enabled: e.target.checked,


                          }))


                        }


                        className="h-4 w-4 rounded border-slate-300 text-slate-900"


                      />


                      <span className="font-semibold text-slate-700">


                        {renderLabelWithTooltip(


                          "Enable customer satisfaction goals",


                          "csat_goal_enabled"


                        )}


                      </span>


                    </label>


                    <p className="text-xs text-slate-500">


                      {reviewFieldHelp.csat_goal_enabled}


                    </p>


                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">


                      <div className="space-y-2">


                        <label className="text-sm md:text-base font-semibold tracking-wide text-slate-500">


                          {renderLabelWithTooltip(


                            "Target average rating (stars)",


                            "csat_goal_target_rating"


                          )}


                        </label>


                        <input


                          type="number"


                          min={1}


                          max={5}


                          step={0.1}


                          value={form.csat_goal_target_rating}


                          onChange={(e) =>


                            setForm((prev) => ({


                              ...prev,


                              csat_goal_target_rating: e.target.value,


                            }))


                          }


                          disabled={!form.csat_goal_enabled}


                          className="h-11 md:h-12 w-full rounded-xl border border-slate-300 px-4 disabled:bg-slate-100"


                        />


                        <p className="text-xs text-slate-500">


                          {reviewFieldHelp.csat_goal_target_rating}


                        </p>


                      </div>


                      <div className="space-y-2">


                        <label className="text-sm md:text-base font-semibold tracking-wide text-slate-500">


                          {renderLabelWithTooltip(


                            "Target number of reviews per week",


                            "csat_goal_target_reviews_per_week"


                          )}


                        </label>


                        <input


                          type="number"


                          min={0}


                          step={1}


                          value={form.csat_goal_target_reviews_per_week}


                          onChange={(e) =>


                            setForm((prev) => ({


                              ...prev,


                              csat_goal_target_reviews_per_week: e.target.value,


                            }))


                          }


                          disabled={!form.csat_goal_enabled}


                          className="h-11 md:h-12 w-full rounded-xl border border-slate-300 px-4 disabled:bg-slate-100"


                        />


                        <p className="text-xs text-slate-500">


                          {reviewFieldHelp.csat_goal_target_reviews_per_week}


                        </p>


                      </div>


                    </div>


                  </div>





                  <div className="rounded-xl border border-slate-200 bg-white p-4 space-y-3">


                    <div className="text-xs font-semibold uppercase tracking-wide text-slate-500">


                      <span id="client-review-followups" className="scroll-mt-24">Follow-up routing</span>
                      <div className="mt-3">
                        <SaveChangesButton saving={saving} />
                      </div>
                    </div>


                    <label className="flex items-center gap-3 text-sm md:text-base text-slate-700">


                      <input


                        type="checkbox"


                        checked={!!form.review_followup_enabled}


                        onChange={(e) =>



                          setForm((prev) => ({



                            ...prev,



                            review_followup_enabled: e.target.checked,



                          }))



                        }


                        className="h-4 w-4 rounded border-slate-300 text-slate-900"


                      />


                      <span className="font-semibold text-slate-700">


                        {renderLabelWithTooltip(


                          "Enable follow-ups",


                          "review_followup_enabled"


                        )}


                      </span>


                    </label>


                    <p className="text-xs text-slate-500">


                      {reviewFieldHelp.review_followup_enabled}


                    </p>


                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">


                      <div className="space-y-2">


                        <label className="text-sm md:text-base font-semibold tracking-wide text-slate-500">


                          {renderLabelWithTooltip(


                            "Threshold (rating or below)",


                            "review_followup_threshold"


                          )}


                        </label>


                        <input


                          type="number"


                          min={1}


                          max={5}



                          step={1}



                          value={form.review_followup_threshold}



                          onChange={(e) =>



                            setForm((prev) => ({



                              ...prev,



                              review_followup_threshold: e.target.value,



                            }))



                          }



                          disabled={!form.review_followup_enabled}



                          className="h-11 md:h-12 w-full rounded-xl border border-slate-300 px-4 disabled:bg-slate-100"



                        />



                        <p className="text-xs text-slate-500">



                          {reviewFieldHelp.review_followup_threshold}



                        </p>



                      </div>


                      <div className="space-y-2">


                        <label className="text-sm md:text-base font-semibold tracking-wide text-slate-500">


                          {renderLabelWithTooltip(


                            "Default assignee",


                            "review_followup_default_assignee_user_id"


                          )}


                        </label>


                        <select


                          value={form.review_followup_default_assignee_user_id || ""}


                          onChange={(e) =>



                            setForm((prev) => ({



                              ...prev,



                              review_followup_default_assignee_user_id: e.target.value,



                            }))



                          }



                          disabled={!form.review_followup_enabled}



                          className="h-11 md:h-12 w-full rounded-xl border border-slate-300 px-4 bg-white disabled:bg-slate-100"



                        >



                          <option value="">No default</option>



                          {salonUsers.map((userItem) => (



                            <option key={userItem.id} value={userItem.id}>



                              {userItem.full_name ||



                                userItem.username ||



                                userItem.email}



                            </option>



                          ))}



                        </select>



                        {salonUsersLoading && (


                          <div className="text-xs text-slate-500">


                            Loading assignees...


                          </div>


                        )}


                        <p className="text-xs text-slate-500">


                          {reviewFieldHelp.review_followup_default_assignee_user_id}


                        </p>


                      </div>


                    </div>


                    <div className="rounded-xl border border-slate-200 bg-slate-50 p-4 space-y-3">


                      <label className="flex items-center gap-3 text-sm md:text-base text-slate-700">


                        <input


                          type="checkbox"


                          checked={!!form.followup_sla_enabled}


                          onChange={(e) =>


                            setForm((prev) => ({


                              ...prev,


                              followup_sla_enabled: e.target.checked,


                            }))


                          }


                          className="h-4 w-4 rounded border-slate-300 text-slate-900"


                        />


                        <span className="font-semibold text-slate-700">


                          {renderLabelWithTooltip(


                            "Enable follow-up time goals",


                            "followup_sla_enabled"


                          )}


                        </span>


                      </label>


                      <p className="text-xs text-slate-500">


                        {reviewFieldHelp.followup_sla_enabled}


                      </p>


                      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">


                        <div className="space-y-2">


                          <label className="text-sm md:text-base font-semibold tracking-wide text-slate-500">


                            {renderLabelWithTooltip(


                              "Time goal to respond (hours)",


                              "followup_sla_hours"


                            )}


                          </label>


                          <input


                            type="number"


                            min={1}


                            step={1}


                            value={form.followup_sla_hours}


                            onChange={(e) =>


                              setForm((prev) => ({


                                ...prev,


                                followup_sla_hours: e.target.value,


                              }))


                            }


                            disabled={!form.followup_sla_enabled}


                            className="h-11 md:h-12 w-full rounded-xl border border-slate-300 px-4 disabled:bg-slate-100"


                          />


                          <p className="text-xs text-slate-500">


                            {reviewFieldHelp.followup_sla_hours}


                          </p>


                        </div>


                        <div className="space-y-2">


                          <label className="text-sm md:text-base font-semibold tracking-wide text-slate-500">


                            {renderLabelWithTooltip(


                              "Send overdue reminder after (hours)",


                              "followup_overdue_reminder_hours"


                            )}


                          </label>


                          <input


                            type="number"


                            min={1}


                            step={1}


                            value={form.followup_overdue_reminder_hours}


                            onChange={(e) =>


                              setForm((prev) => ({


                                ...prev,


                                followup_overdue_reminder_hours: e.target.value,


                              }))


                            }


                            disabled={!form.followup_sla_enabled}


                            className="h-11 md:h-12 w-full rounded-xl border border-slate-300 px-4 disabled:bg-slate-100"


                          />


                          <p className="text-xs text-slate-500">


                            {reviewFieldHelp.followup_overdue_reminder_hours}


                          </p>


                        </div>


                        <div className="space-y-2">


                          <label className="text-sm md:text-base font-semibold tracking-wide text-slate-500">


                            {renderLabelWithTooltip(


                              "Fallback notify email",


                              "followup_manager_notify_email"


                            )}


                          </label>


                          <input


                            type="email"


                            value={form.followup_manager_notify_email}


                            onChange={(e) =>


                              setForm((prev) => ({


                                ...prev,


                                followup_manager_notify_email: e.target.value,


                              }))


                            }


                            className="h-11 md:h-12 w-full rounded-xl border border-slate-300 px-4"


                            placeholder="manager@salon.com"


                          />


                          <p className="text-xs text-slate-500">


                            {reviewFieldHelp.followup_manager_notify_email}


                          </p>


                        </div>


                      </div>


                      <label className="flex items-center gap-3 text-sm md:text-base text-slate-700">


                        <input


                          type="checkbox"


                          checked={!!form.followup_auto_assign_enabled}


                          onChange={(e) =>


                            setForm((prev) => ({


                              ...prev,


                              followup_auto_assign_enabled: e.target.checked,


                            }))


                          }


                          className="h-4 w-4 rounded border-slate-300 text-slate-900"


                        />


                        <span className="font-semibold text-slate-700">


                          {renderLabelWithTooltip(


                            "Auto-assign follow-ups",


                            "followup_auto_assign_enabled"


                          )}


                        </span>


                      </label>


                      <p className="text-xs text-slate-500">


                        {reviewFieldHelp.followup_auto_assign_enabled}


                      </p>


                    </div>


                  </div>


                </div>





                <div id="client-review-email" className="order-3 rounded-2xl border border-slate-200 bg-white p-6 space-y-6 scroll-mt-24">
                  <div className="flex flex-wrap items-start justify-between gap-3">
                    <div>
                    <h3 className="text-lg md:text-xl font-semibold text-slate-900">


                      Review Email Message


                    </h3>


                    <p className="text-sm text-slate-500">


                      Customize the message clients receive after their service.


                    </p>


                    </div>
                    <SaveChangesButton saving={saving} />
                  </div>



                  <label className="flex items-center gap-3 text-sm md:text-base text-slate-700">


                    <input


                      type="checkbox"


                      checked={!!form.review_email_template_enabled}


                      onChange={(e) =>


                        setForm((prev) => ({


                          ...prev,


                          review_email_template_enabled: e.target.checked,


                        }))


                      }


                      className="h-4 w-4 rounded border-slate-300 text-slate-900"


                    />


                    <span className="font-semibold text-slate-700">


                      {renderLabelWithTooltip(


                        "Use custom message",


                        "review_email_template_enabled"


                      )}


                    </span>


                  </label>


                  <p className="text-xs text-slate-500">


                    {reviewFieldHelp.review_email_template_enabled}


                  </p>





                  <div className="grid grid-cols-1 lg:grid-cols-[minmax(0,1fr)_minmax(0,1fr)] gap-6">


                    <div className="space-y-4">


                      <div className="space-y-2">


                        <label className="text-sm md:text-base font-semibold tracking-wide text-slate-500">


                          {renderLabelWithTooltip(


                            "Subject",


                            "review_email_subject"


                          )}


                        </label>


                        <input


                          ref={subjectRef}


                          type="text"


                          value={form.review_email_subject}


                          onChange={(e) =>


                            setForm((prev) => ({


                              ...prev,


                              review_email_subject: e.target.value,


                            }))


                          }


                          onFocus={() => setActiveField("subject")}


                          disabled={!form.review_email_template_enabled}


                          className="h-11 md:h-12 w-full rounded-xl border border-slate-300 px-4 disabled:bg-slate-100"


                        />


                        <p className="text-xs text-slate-500">


                          {reviewFieldHelp.review_email_subject}


                        </p>


                      </div>


                      <div className="space-y-2">


                        <label className="text-sm md:text-base font-semibold tracking-wide text-slate-500">


                          {renderLabelWithTooltip(


                            "Message body",


                            "review_email_body"


                          )}


                        </label>


                        <textarea


                          ref={bodyRef}


                          rows={7}


                          value={form.review_email_body}


                          onChange={(e) =>


                            setForm((prev) => ({


                              ...prev,


                              review_email_body: e.target.value,


                            }))


                          }


                          onFocus={() => setActiveField("body")}


                          disabled={!form.review_email_template_enabled}


                          className="w-full rounded-2xl border border-slate-300 px-4 py-3 text-sm md:text-base disabled:bg-slate-100"


                        />


                        <p className="text-xs text-slate-500">


                          {reviewFieldHelp.review_email_body}


                        </p>


                      </div>





                      <div className="space-y-2">


                        <div className="text-xs font-semibold uppercase tracking-wide text-slate-500 inline-flex items-center gap-2">


                          {renderLabelWithTooltip(


                            "Tokens",


                            "review_email_tokens"


                          )}


                        </div>


                        <div className="flex flex-wrap gap-2">


                          {EMAIL_TOKENS.map((tokenValue) => (


                            <button


                              key={tokenValue}


                              type="button"


                              onClick={() => handleTokenInsert(tokenValue)}


                              title="Click to copy"


                              className="rounded-full border border-slate-300 px-3 py-1 text-xs font-semibold text-slate-600 hover:bg-slate-50"


                            >


                              {tokenValue}


                            </button>


                          ))}


                        </div>


                      </div>





                      <div className="flex flex-wrap items-center gap-2">


                        <button


                          type="button"


                          onClick={() =>


                            setForm((prev) => ({


                              ...prev,


                              review_email_subject:


                                DEFAULT_FORM.review_email_subject,


                              review_email_body: DEFAULT_FORM.review_email_body,


                            }))


                          }


                          className="rounded-full border border-slate-300 px-4 py-2 text-xs font-semibold text-slate-700 hover:bg-slate-50"


                        >


                          Reset to default


                        </button>


                      </div>


                    </div>





                    <div className="rounded-2xl border border-slate-200 bg-slate-50 p-4 space-y-3">


                      <div className="flex items-center justify-between gap-2">


                        <div className="text-xs font-semibold uppercase tracking-wide text-slate-500 inline-flex items-center gap-2">


                          {renderLabelWithTooltip(


                            "Email preview",


                            "review_email_preview"


                          )}


                        </div>


                        <div className="text-xs text-slate-500">


                          Preview uses sample values.


                        </div>


                      </div>


                      <div className="rounded-xl border border-slate-200 bg-white px-3 py-2 text-xs text-slate-600">


                        <div>


                          <span className="font-semibold text-slate-700">From:</span>{" "}


                          {(salonName || "Your Salon") + " via Ellyanna <no-reply@ellyanna.com>"}
                        </div>


                        <div>


                          <span className="font-semibold text-slate-700">To:</span>{" "}


                          client@example.com


                        </div>


                        <div>


                          <span className="font-semibold text-slate-700">Subject:</span>{" "}


                          {previewSubject || "No subject"}


                        </div>


                      </div>


                      <SafeHtml


                        className="rounded-xl border border-slate-200 bg-white px-3 py-3 text-sm text-slate-700 whitespace-pre-wrap"


                         html={previewBodyHtml} />


                    </div>


                  </div>


                </div>





                <div className="order-3 flex items-center gap-2">
                  <button


                    type="submit"


                    disabled={saving}


                    className="h-11 md:h-12 px-6 rounded-full bg-slate-900 text-white text-base md:text-lg font-semibold hover:bg-slate-800 disabled:opacity-60"



                  >



                    {saving ? "Saving..." : "Save Changes"}



                  </button>



                </div>



                </div>

              </form>
            )}



          </div>



        </div>



      </div>



    </div>



  );



}



